
import { ConversionHelper } from '@/helpers/ConversionHelper';
import { Mutation } from 'vuex-class';
import { CustomerService } from '@/services/customer-service';
import { OrdersService } from '@/services/orders-service';
import { Address } from '@/store/models/AddressModel';
import { OrderlineDetails } from '@/store/models/OrderlineModel';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import RollDirectionAlert from '@/components/RollDirectonAlert.vue';
import AddEditShippingAddressForm from './AddEditShippingAddressForm.vue';
import { ItemState } from '@/store/models/ItemModel';
import { DisableFieldAutofill, Wait } from '@/helpers/WebHelper';
@Component({
  components: {
    RollDirectionAlert,
    AddEditShippingAddressForm
  }
})
export default class AddEditShippingAddress extends Vue {
  $refs!: {
    defaultActions: HTMLFormElement;
    AddEditShippingAddressForm: HTMLFormElement;
  };
  /* Properties */
  @Prop() originalAddress!: Address;
  @Prop() dialogTitle!: string;
  /* Store Actions */
  @Mutation('setCurrentOrder', { namespace: 'orderlines' })
  setCurrentOrderInStore: any;
  /* Watchers */
  @Watch('addressToEdit.Country.Id')
  onCountryIdChange() {
    if (!!this.originalAddress.State || !!this.originalAddress.Province) return;
    if (this.addressToEdit.Country.Id > 1 && this.addressToEdit.State != '') {
      this.addressToEdit.State = '';
    } else {
      this.addressToEdit.Province = '';
    }
  }
  @Watch('addressToEdit', { deep: true })
  onAddressToEditChange(val: any, oldVal: any) {
    if (
      oldVal.Status == ItemState.New ||
      (oldVal.Status === ItemState.Edit && oldVal.Id && this.hasLoadedAddress)
    ) {
      this.addressToEdit.HasChanged = true;
    }
  }
  /* Data */
  shouldShowAlert: boolean = false;
  hasLoadedAddress: boolean = false;
  // isSavingBillingAddress: boolean = false;
  addressToEdit: Address = new Address();
  selectedRollDirectionId: number | null = null;
  shouldOpenDialog: boolean = false;
  isFormValid: boolean = false;
  isSavingAddress: boolean = false;
  shouldCreateNewAddress: boolean = true;
  additionalAlert: string = '';
  /* Utility Functions */
  async openAddressDialog(
    shouldClearData: boolean = false,
    addressToEdit: Address | null = null,
    additionalAlert: string = ''
  ) {
    this.additionalAlert = additionalAlert;
    if (shouldClearData || !this.originalAddress) {
      this.addressToEdit = new Address();
    } else {
      Object.assign(this.addressToEdit, this.originalAddress);
      this.hasLoadedAddress = true;
    }
    if (addressToEdit) {
      this.addressToEdit = addressToEdit;
      this.shouldCreateNewAddress = false;
    }
    this.shouldOpenDialog = true;
    Wait(() => {
      this.$refs.AddEditShippingAddressForm.setAddress(this.addressToEdit);
    });
  }

  async updateAddress() {
    this.isSavingAddress = true;
    this.addressToEdit = this.$refs.AddEditShippingAddressForm.getAddress();
    const shouldUpdateAddress =
      (this.originalAddress && this.originalAddress.Id) || !this.shouldCreateNewAddress;
    let model = ConversionHelper.convertAddressToAddressModel(
      this.addressToEdit,
      !shouldUpdateAddress,
      this.addressToEdit.IsBilling
    );
    if (shouldUpdateAddress) {
      const { data } = await CustomerService.UpdateAddress(model);
      await this.$refs.AddEditShippingAddressForm.updateOrderline(
        this.selectedRollDirectionId!
      );
      this.$emit('addressUpdated', new Address(data));
    } else {
      const { data } = await CustomerService.AddNewShippingAddress(model);
      this.$emit('addressUpdated', data);
    }
    this.isSavingAddress = false;
    this.shouldOpenDialog = false;
  }
  async updateOrderlineCallback(orderlines: OrderlineDetails[]) {
    const loadedOrderlines = this.$store.getters['orderlines/orderlines'];
    for (let i = 0; i < orderlines.length; i++) {
      let oldIndex = loadedOrderlines.findIndex((ol: any) => ol.Id === orderlines[i].Id);
      if (oldIndex > -1) {
        loadedOrderlines[oldIndex] = new OrderlineDetails(orderlines[i]);
      }
    }
    this.setCurrentOrderInStore(loadedOrderlines);
  }
  closeAlert() {
    this.shouldShowAlert = false;
  }
  /* Loaders */
  /* Computed */
  /* Mounted */
  /* Created */
}
